import { Parallax } from "react-parallax";
import me from '../artifact/me001.JPG';
import { motion, useScroll, useTransform, useInView, useAnimation } from "framer-motion";
import { useRef, useEffect } from "react";
import linkedLogo from '../artifact/icons8-linkedin-80.png';
import githubLogo from '../artifact/icons8-github-100.png';
import resumeLogo from '../artifact/icons8-resume-100.png';
import myresume from '../artifact/Bunphengchhay_01_2026.pdf';

import { useState } from 'react';

function Overview({toggleEnableChatbot, isChatbotEnable}) {
    const [isReadMore, setIsReadMore] = useState(false)
    const name = "Hey, I'm Bunpheng".split("").map(char => char === " " ? "\u00A0" : char);
    const controls = useAnimation();
    const nameRef = useRef(null);
    const isInView = useInView(nameRef, { threshold: 0.5 }); // { once: true } or `{ amount: 0.5 }` for partial visibility
    const containerRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["start 0%", "end 5%"]

    });

    const scale = useTransform(scrollYProgress, [0, 1], [1, 0.7]);
    const opacity = useTransform(scrollYProgress, [0, 1], [1, 0]);

    const letterVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: (i) => ({
        y: 0,
        opacity: 1,
        transition: {
            delay: i * 0.09,
            type: "spring",
            stiffness: 500,
            damping: 30,
        },
        }),
    };

    useEffect(() => {
        if (isInView) {
        controls.start("visible");
        } else {
        controls.start("hidden"); // Reset animation when out of view
        }
    }, [isInView, controls]);
    

    const containerVariants = {
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.3,
        },
      },
    };
    
    const itemVariants = {
      hidden: { opacity: 0, y: 20 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
    };
    
    const bounceTransition = {
      y: {
        duration: 1.5,
        yoyo: Infinity,  // repeat forever
        ease: "easeOut",
      },
    };

  return (
    <div className='w-full'>
      <section className="w-full h-auto flex flex-col items-center justify-center md:flex-row mb-7 md:mb-25 ">
        <div className='w-full flex-1 text-center'>
          <h1
            ref={nameRef}
            className="text-4xl font-bold mb-2 flex justify-center whitespace-pre-wrap"
            >
            {name.map((char, i) => (
                <motion.span
                key={i}
                custom={i}
                initial="hidden"
                animate={controls}
                variants={letterVariants}
                className="inline-block"
                >
                {char}
                </motion.span>
            ))}
            </h1>

          <p className='text-sm'> I'm a Software Engineer </p>
          <p className='text-sm'>
            Leveraging AIML and Cloud Infrastructure to build impactful applications and improve user's experiences
          </p>
          <p className='text-sm text-gray-500 mt-2'>Currently @Boehringer Ingelheim · Previously @Intel · @AWS · @Kismet XYZ</p>
            {/* <GetMetrics/> */}
        </div>  
      </section>

      {/* Image Parallax */}
      <div className='w-full relative z-20 mb-10'>
        <Parallax
          bgImage={me}
          strength={-400}
          bgImageStyle={{
            objectFit: 'cover',
            objectPosition: 'center',
            transform: 'scale(0.5)'
          }}
          className='w-full h-[600px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[1200px] rounded-3xl'
        />
      </div>

      {/* Scroll spacer to enable animation */}
      <div className='h-auto relative'>
        <div ref={containerRef} className='sticky '>
          <motion.div
            style={{ scale, opacity }}
            className='w-full bg-stone-800 text-sm rounded-3xl p-6 text-white shadow-lg'
          >
            <h1 className='text-4xl font-bold mb-0 text-white'> About Me</h1>
            <p className=' text-sm mb-2 mt-0 text-yellow-500'> I am a Software Engineer</p>

            <div>
              <p>
                I’ve built and demo serverless AIML applications at <strong>AWS</strong>, created manufacturing analytics tools at <strong>Intel</strong>, developed and shipped agentic RAG systems and full‑stack platforms at <strong>Kismet XYZ</strong>, and now support large‑scale model infrastructure and system design as an MLOps Engineer at <strong>Boehringer Ingelheim</strong>. I also enjoy developing web applications and internal dashboards that support small businesses and streamline data workflows. 
              </p>
              <br/>
              <button className="underline" onClick={() => setIsReadMore(!isReadMore)}>
                {isReadMore ? 'Show Less' : 'Read More'}
              </button>

              {isReadMore && (
                <div className="mt-4">
                  <p>
                    I approach engineering with a people first mindset shaped by early experience in service and leadership roles. Moving into tech allowed me to combine that foundation with a passion for building intelligent systems that create real impact for users, teams, and organizations.
                    <br /><br />
                    Before transitioning into software engineering, I developed strong skills in communication, problem solving, and team leadership skills that continue to shape how I design and deliver technical solutions. I later earned a B.S. in Computer Science from Sacramento State and am now pursuing an M.S. in Data Science at Boston University with a focus on machine learning and scalable systems.
                    <br /><br />
                    Across every role, I’m focused on building reliable, human centered systems that turn complex data and AI into meaningful, scalable solutions.
                  </p>
                </div>
              )}
            </div>

            <div className='mt-5'>
                <p> Bunpheng Chhay (Pence)</p>
                <p> pencechhay@gmail.com</p>
                <p> 609-742-9679</p>
                <p> Boston, Massachusettes</p>
            </div>
            <div className="flex justify-center mt-3 gap-6">
            {myContact.map((item, index) => (
              <div key={index} className="flex flex-col items-center">
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  download={item.title === "resume"}
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="w-[50px] h-[40px] object-contain hover:scale-110 transition-transform duration-200"
                  />
                </a>

                <p className="text-xs mt-1">{item.title}</p>
              </div>
            ))}

            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Overview;

const myContact = [
    {
        title: 'resume',
        link: myresume,
        icon: resumeLogo
    },
    {
        title: 'linkedin',
        link: 'https://www.linkedin.com/in/bunphengchhay/',
        icon: linkedLogo
    },
    {
        title: 'github',
        link: 'https://github.com/Bunphengchhay',
        icon: githubLogo
    },
]
